export default class User {
    private _id: string = ''; // ueii

    private _isConnected: boolean = false;
    private _isPremium: boolean = false; // ueia
    private _canComment: boolean = false; // ueio
    private _isBlackListed: boolean = true; // ueib

    private _nom: string = '';
    private _prenom: string = '';
    private _civilite: string = '';
    private _pseudo: string = '';

    constructor() {
        if (document.ueii != null && document.ueii != '') {
            // Identifiant
            this._id = document.ueii;
            // is Connected ?
            this._isConnected = true;
        }
        // is Premium ?
        if (document.ueia != null && document.ueia.toString() === '1') {
            this._isPremium = true;
        }
        // can Comment ?
        if (document.ueio != null && document.ueio.toString() === '1') {
            this._canComment = true;
        }
        // is BlackListed ?
        if (document.ueib != null && document.ueib.toString() === '0') {
            this._isBlackListed = false;
        }
        // Nom
        if (document.uein != null) {
            this._nom = document.uein;
        }
        // Prénom
        if (document.ueip != null) {
            this._prenom = document.ueip;
        }
        // Civilité
        if (document.ueic != null) {
            this._civilite = document.ueic;
        }
        // Pseudo
        if (document.ueis != null) {
            this._pseudo = document.ueis;
        }
    }

    public get id() {
        return this._id;
    }

    public get isConnected() {
        return this._isConnected;
    }
    public get isPremium() {
        return this._isPremium;
    }
    public get canComment() {
        return this._canComment;
    }
    public get isBlackListed() {
        return this._isBlackListed;
    }

    public get nom() {
        return this._nom;
    }
    public get prenom() {
        return this._prenom;
    }
    public get civilite() {
        return this._civilite;
    }
    public get pseudo() {
        return this._pseudo;
    }

    private set pseudo(value) {
        this._pseudo = value;
        document.ueis = value;
    }
}
